export default __webpack_public_path__ + "static/media/Admission.bc431fa8.svg";